import { clearFields } from "redux-form";

export const getCardknoxData =
  (retries = 0) =>
  async (dispatch, getState, api) => {
    const cardknoxData = await new Promise((resolve, reject) => {
      // getTokens is defined on the window. See https://docs.cardknox.com/cardknox-products/ifields#step-3-js
      getTokens(
        async function () {
          const cardNumToken = document.getElementById("xCardNum").value;
          const cvvNumToken = document.getElementById("xCVV").value;
          resolve({ cardNumToken, cvvNumToken });
        },
        function (e) {
          console.error("error getting cardknox tokens", e);
          reject(e);
        },
        10 * 1000 // timeout in milliseconds
      );
    });
    if (!cardknoxData.cardNumToken || !cardknoxData.cvvNumToken) {
      if (retries < 3) {
        retries++;
        return await dispatch(getCardknoxData(retries));
      } else {
        // clearing the the credit card form.
        clearIfield("card-number");
        clearIfield("cvv");
        dispatch(
          clearFields(
            "mailCheckSell",
            false,
            false,
            "verification.creditCardInformation.ExpirationDate"
          )
        );
        dispatch(
          clearFields(
            "achSell",
            false,
            false,
            "verification.creditCardInformation.ExpirationDate"
          )
        );
        dispatch(
          clearFields(
            "tradeOptionSell",
            false,
            false,
            "verification.creditCardInformation.ExpirationDate"
          )
        );
        dispatch(
          clearFields(
            "payPalSell",
            false,
            false,
            "verification.creditCardInformation.ExpirationDate"
          )
        );
        dispatch(
          clearFields(
            "mainCheckoutBuy",
            false,
            false,
            "creditCardInformation.ExpirationDate"
          )
        );
        dispatch(
          clearFields(
            "addACreditCard",
            false,
            false,
            "creditCardInformation.ExpirationDate"
          )
        );
        dispatch(
          clearFields(
            "mainCheckoutBuy",
            false,
            false,
            "paymentInfoForACH.creditCardInformation.ExpirationDate"
          )
        );

        throw new Error(
          "Please re-enter your credit card information and try again."
        );
      }
    }
    return cardknoxData;
  };
